export const props = Object.freeze({
  /**
   * Name of the thing being targeted, as the surrounding form calls it — "Ratings Target",
   * "Recommendations Target". Varies per mount, and the mode links are phrased around it.
   *
   * @type {String}
   * @default undefined
   */
  targetName: {
    type: String,
    default: undefined,
  },
  /**
   * Free-text target: a relative path, or an external URL. Empty when a record is selected.
   *
   * @type {String}
   * @default ""
   */
  targetUrl: {
    type: String,
    default: "",
  },
  /**
   * Id of the selected record, empty when the target is a plain URL.
   *
   * @type {String}
   * @default ""
   */
  recordId: {
    type: String,
    default: "",
  },
  /**
   * Class name of the selected record, empty unless the surrounding field is polymorphic.
   *
   * @type {String}
   * @default ""
   */
  recordType: {
    type: String,
    default: "",
  },
  /**
   * Internal `sparkle://` link for the selected record. Its presence is what the preview is
   * fetched for; `resolveMetaDataUrl` maps it to the admin endpoint that describes the record.
   *
   * @type {String}
   * @default ""
   */
  sparkleUrl: {
    type: String,
    default: "",
  },
  /**
   * CSS selector for the light-DOM inputs the surrounding Rails form submits. The element writes
   * the selection into them, so the form keeps its own field names.
   *
   * @type {String}
   * @default '[data-behaviour~="url-input"]'
   */
  urlInputSelector: {
    type: String,
    default: '[data-behaviour~="url-input"]',
  },
  /**
   * CSS selector for the record-search widget the surrounding form rendered into the search slot.
   *
   * @type {String}
   * @default ".target-search"
   */
  searchSelector: {
    type: String,
    default: ".target-search",
  },
  /**
   * @type {String}
   * @default '[data-behaviour~="record-id-input"]'
   */
  idInputSelector: {
    type: String,
    default: '[data-behaviour~="record-id-input"]',
  },
  /**
   * @type {String}
   * @default '[data-behaviour~="record-type-input"]'
   */
  typeInputSelector: {
    type: String,
    default: '[data-behaviour~="record-type-input"]',
  },
});
